import { MAIN } from "../../../routes/constants";
import BusinessPartner from "./BusinessPartner";
import ViewBusinessPartner from "./ViewBusinessPartner";

//Module Page Routes
export const BUSINESS_PARTNER = MAIN + "/BusinessPartner";
export const ADD_BUSINESS_PARTNER = BUSINESS_PARTNER + "/new";
export const EDIT_BUSINESS_PARTNER = BUSINESS_PARTNER + "/edit";

const BusinessPartnerRoutes = [
{
    label: "BUSINESS_PARTNER",
    path: BUSINESS_PARTNER,
    component: BusinessPartner,
    exact: true,
    mainscreen:true
}
,{
    label: "ADD BUSINESS_PARTNER",
    path: ADD_BUSINESS_PARTNER + "/:id?",
    component: ViewBusinessPartner,
    exact: true
}
,{
    label: "EDIT BUSINESS_PARTNER",
    path: EDIT_BUSINESS_PARTNER + "/:id?",
    component: ViewBusinessPartner,
    exact: true
}
];

export default BusinessPartnerRoutes;